import * as Sentry from '@sentry/react';
import { setFeedbackPrefill } from './feedbackPrefill.js';

export interface ObservabilityUser {
  userHandle: string;
  /** Feedback-form prefill only — never sent to Sentry via setUser. */
  name?: string;
  /** Feedback-form prefill only — never sent to Sentry via setUser. */
  email?: string;
}

export function setObservabilityUser(user: ObservabilityUser | null) {
  Sentry.setUser(user ? { id: user.userHandle } : null);
  setFeedbackPrefill(user?.name && user?.email ? { name: user.name, email: user.email } : null);
}

export function setTeamContext(team: string, feature?: string) {
  Sentry.setTag('team', team);
  if (feature) {
    Sentry.setTag('feature', feature);
  }
}

export function createSentryFlagPropagator(): (flags: Record<string, boolean | string>) => void {
  return (flags) => {
    Sentry.setContext('feature_flags', flags);
  };
}
